"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[868],{

/***/ 1032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_HomePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Contactblock/Contactblock.tsx



function Contactblock() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "streamfield text-block contactblock",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: "icon",
                    priority: true,
                    src: "/contact.svg",
                    alt: "Telefon-Icon",
                    height: 48,
                    width: 48
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Haben Sie noch eine Frage?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Unser Team hilft Ihnen gerne weiter."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/anfrage",
                    className: "button contactblock",
                    children: "Zur Anfrage"
                })
            ]
        })
    });
}
/* harmony default export */ var Contactblock_Contactblock = (Contactblock);

;// CONCATENATED MODULE: ./src/components/Contactblock/index.tsx

/* harmony default export */ var components_Contactblock = (Contactblock_Contactblock);

// EXTERNAL MODULE: ./src/components/Hero/index.tsx + 3 modules
var Hero = __webpack_require__(1223);
// EXTERNAL MODULE: ./src/streamfields/Streamfields.tsx + 40 modules
var Streamfields = __webpack_require__(1594);
// EXTERNAL MODULE: ./src/views/BasePage/index.tsx + 1 modules
var BasePage = __webpack_require__(4257);
;// CONCATENATED MODULE: ./src/views/HomePage/HomePage.tsx





function HomePage(props) {
    const { title , body , content , show_contact , showContactSticky  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "home-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                title: title,
                subtitle: body,
                showContactSticky: showContactSticky
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-page",
                children: content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Streamfields/* default */.Z, {
                    fields: content
                }) : null
            }),
            show_contact ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Contactblock, {}) : null
        ]
    });
}
/* harmony default export */ var HomePage_HomePage = ((0,BasePage/* basePageWrap */.P)(HomePage));

;// CONCATENATED MODULE: ./src/views/HomePage/index.tsx

/* harmony default export */ var views_HomePage = (HomePage_HomePage);


/***/ })

}]);